var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('register-search-form',{attrs:{"notice-list":['복사등록 하실 파트너사의 사업자 정보를 조회하세요.']}})}
var staticRenderFns = []

export { render, staticRenderFns }